<template>
  <VueDatePicker
    :clearable="clearable"
    locale="pt-br"
    :enable-time-picker="false"
    format="dd/MM/yyyy"
    multi-calendars
    placeholder="Selecione o período"
    :model-value="date"
    @update:model-value="handleDateChange"
    :ui="{
      input: 'form-select datepicker-custom-class',
    }"
    :range="{ maxRange: 31 }"
  />
</template>

<script setup lang="ts">
import { DateFilterConfig } from "@/@types";
import moment, { Moment } from "moment";
import { ref, watch } from "vue";

const emits = defineEmits(["onDateChange"]);

const { range, clearable = true } = defineProps<DateRangeProps>();

const date = ref([range?.date_start, range?.date_end]);

watch(
  () => range,
  (newRange) => {
    date.value = [newRange?.date_start, newRange?.date_end];
  }
);

const handleDateChange = (newRange: any) => {
  let date_start: Moment | string = "";
  let date_end: Moment | string = "";
  if (newRange && newRange[1]) {
    date.value = newRange;
    date_start = moment(newRange[0]);
    date_end = moment(newRange[1]);
  }
  emits("onDateChange", { date_start, date_end });
};

export type DateRangeProps = {
  clearable?: boolean;
  range?: DateFilterConfig;
};
</script>

<style>
.datepicker-custom-class {
  padding-left: 2.2rem;
  --bs-form-select-bg-img: unset;
}
</style>
